import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { Nav, Navbar, Container } from 'react-bootstrap';
import axios from 'axios';

import { useAuthState } from '../../services/auth';

const appNames = ['dde', 'mongo', 'mqtt', 'redis'];

export const Manager = ({ children }: any) => {
    const { token } = useAuthState();
    const location = useLocation();
    const isManager = location.pathname.includes('manager');
    //const [serviceStatus, setServiceStatus] = useState<any>()

   /*  async function fetchServiceStatus() {
        const data2 = await axios.get('/op/services-status');
        setServiceStatus(data2?.data)
    }

    useEffect(() => {
        if (token) {
            fetchServiceStatus();
        }
    }, [token]); */
    return (
        isManager ?
        (<section id="home">
            <header>
                {/*  {breadcrumbs.map(({ breadcrumb }) => breadcrumb)} */}
                <span className='title-home'>Manager</span>

                <div className='status-container'>
                    <div>
                        <strong><Link to="/operators">Operators</Link></strong>
                    </div>
                    <div>
                        <strong><Link to="/dashboard">Manager</Link></strong>
                    </div>
                   {/*  {appNames.map(item =>
                        <div key={item}>
                            <strong>{item}:</strong> <span className={'status'}>{serviceStatus[item] ? 'online' : 'offline'}</span>
                        </div>
                    )} */}
                </div>
            </header>
            <Navbar bg="light" expand="lg">
                <Container>
                    <Navbar.Brand>Manager</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link>
                                <Link to="/manager/dashboard">Dashboard</Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/manager/dnsquery">Filter Queries</Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/manager/dnsresponse">Filter Responses</Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/manager/redisips">Redis Ips</Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/manager/trustedips">Trusted Ips</Link>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            <Container>
                {children}
            </Container>

        </section>)
        :
        <></>
    )
}
